<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('审核状态')" prop="contractStatus">
                <a-select :placeholder="$t('请选择')+$t('审核状态')" v-model="queryParam.contractStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.ExtraApplyStatusEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('内部商户号')" prop="merInnerNo">
                <a-input v-model="queryParam.merInnerNo" :maxLength="32" :placeholder="$t('请输入')+$t('内部商户号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商户注册名称')" prop="merRegName">
                <a-input v-model="queryParam.merRegName" :maxLength="32" :placeholder="$t('请输入')+$t('商户注册名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="商户经营名称" prop="merBizName">
                  <a-input v-model="queryParam.merBizName" :maxLength="32" :placeholder="$t('请输入')+'商户经营名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="营业执照名称" prop="merBlisName">
                  <a-input v-model="queryParam.merBlisName" :maxLength="32" :placeholder="$t('请输入')+'营业执照名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="营业执照号" prop="merBlis">
                  <a-input v-model="queryParam.merBlis" :maxLength="32" :placeholder="$t('请输入')+'营业执照号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="法人姓名" prop="larName">
                  <a-input v-model="queryParam.larName" :maxLength="32" :placeholder="$t('请输入')+'法人姓名'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="法人身份证号码" prop="larIdcard">
                  <a-input v-model="queryParam.larIdcard" :maxLength="32" :placeholder="$t('请输入')+'法人身份证号码'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商户联系人手机" prop="merContactMobile">
                  <a-input v-model="queryParam.merContactMobile" :maxLength="32" :placeholder="$t('请输入')+'商户联系人手机号码'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="商户联系人" prop="merContactName">
                  <a-input v-model="queryParam.merContactName" :maxLength="32" :placeholder="$t('请输入')+'商户联系人'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户开户行号" prop="openingBankCode">
                  <a-input v-model="queryParam.openingBankCode" :maxLength="32" :placeholder="$t('请输入')+'结算账户开户行号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户开户行名称" prop="openingBankName">
                  <a-input v-model="queryParam.openingBankName" :maxLength="32" :placeholder="$t('请输入')+'结算账户开户行名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户账号" prop="acctNo">
                  <a-input v-model="queryParam.acctNo" :maxLength="32" :placeholder="$t('请输入')+'结算账户账号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算账户名称" prop="acctName">
                  <a-input v-model="queryParam.acctName" :maxLength="32" :placeholder="$t('请输入')+'结算账户名称'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算周期" prop="settlePeriod">
                  <a-select v-model="queryParam.settlePeriod" :placeholder="$t('请输入')+'结算周期'">
                    <a-select-option v-for="(item, index) in customDict.SettleCycleEnum" :value="item.type" :key="index">{{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="进件ID" prop="contractId">
                  <a-input v-model="queryParam.contractId" :maxLength="32" :placeholder="$t('请输入')+'进件ID'" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="银联商户号" prop="merCupNo">
                  <a-input v-model="queryParam.merCupNo" :maxLength="32" :placeholder="$t('请输入')+'银联商户号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 " :sm="6">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['merchant:extraapplylakala:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button @click="showWeixinCode" >
          <a-icon type="plus" />微信认证
        </a-button>
        <a-button type="primary" @click="showWeixinHelp" >
          <a-icon type="eye" />点击查看如何微信认证
        </a-button>
        <a-button @click="showAlipayCode" >
          <a-icon type="plus" />支付宝认证
        </a-button>
        <a-button type="primary" @click="showAlipayHelp" >
          <a-icon type="eye" />点击查看如何支付宝认证
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:extraapplylakala:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['merchant:extraapplylakala:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :merchantId="merchantId"
        :merchantType="merchantType"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '140%' }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="contractStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExtraApplyStatusEnum" :value="record.contractStatus"/>
        </span>
        <span slot="splitStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExtraSplitStatusEnum" :value="record.splitStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:extraapplylakala:edit']">
             <a-icon type="edit" />{{$t('修改进件信息')}}
            <br>
          </a>
          <!-- <a-divider type="vertical" v-hasPermi="['merchant:extraapplylakala:remove']" />
         <a @click="handleDelete(record)" v-hasPermi="['merchant:extraapplylakala:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>-->
          <a @click="handleEc(record)" style="color: #f30202" v-if="!record.contractNo">
            <a-icon type="edit" />电子合同签署
            <br>
          </a>
          <a @click="handleEcDownload(record)"  v-if="record.contractNo">
            <a-icon type="download" />电子合同下载
            <br>
          </a>
          <a @click="handleLakalaApply(record)" style="color: #f30202"  v-if="!record.contractId">
            <a-icon type="edit" />进件
            <br>
          </a>
          <a @click="handleLakalaApply(record)"  style="color: #f30202" v-if="record.contractStatus==='MANUAL_AUDIT' || record.contractStatus==='INNER_CHECK_REJECTED' ">
            <a-icon type="edit" />重新进件
             <br>
          </a>
          <a @click="handleLakalaEdit(record)"  v-if="false ">
            <a-icon type="edit" />修改进件<br>
          </a>
          <a @click="handleLedgerApply(record)"  style="color: #f30202" v-if="(!record.splitStatus || record.splitStatus==='INVALID' ) && record.contractNo && record.merCupNo">
            <a-icon type="edit" />分账申请开通
            <br>
          </a>
<!--          <a @click="handleLedgerUpdate(record)"  v-if="record.splitStatus==='INVALID' ">
            <a-icon type="edit" />分账重新开通
            <br>
          </a>-->
          <a @click="handleLedgerReceiver(record)"  style="color: #f30202" v-if="record.receiverCount===0 && record.splitStatus==='VALID' ">
            <a-icon type="edit" />申请分账接收方
            <br>
          </a>
          <a @click="handleBind(record)"  style="color: #f30202" v-if="record.isShowBind ">
            <a-icon type="edit" />绑定分账关系
            <br>
          </a>
          <a @click="$refs.bindList.handleDetail(record.merCupNo)"  v-if="record.splitStatus && record.merCupNo">
            <a-icon type="eye" />查看分账关系<br>
          </a>
          <a  @click="$refs.subInfoList.handleDetail(record.id)" v-if="record.splitStatus && record.merCupNo">
            <a-icon type="eye" />查看渠道报备<br>
          </a>
           <a  @click="$refs.lakalaBalance.handleDetail(record.id)" v-if="record.splitStatus && record.merCupNo">
            <a-icon type="eye" />查看账户余额<br>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <bind-list ref="bindList" ></bind-list>
    <sub-info-list ref="subInfoList"></sub-info-list>
    <lakala-balance ref="lakalaBalance"></lakala-balance>/
  </page-header-wrapper>
</template>

<script>
import {
  pageExtraApplyLakala,
  extraApplyLakalaApply,
  delExtraApplyLakala,
  signExtraApplyEc,
  downloadExtraApplyEc,
  extraApplyLedgerApply,
  ledgerBind,
  extraApplyLedgerApplyReceiverNo,
  extraApplyLedgerUpdate, subInfo, extraApplyLakalaEdit
} from '@/api/merchant/extraApplyLakala'
import { listMerchantApply } from '@/api/merchant/merchantApply'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import BindList from './modules/BindList.vue'
import SubInfoList from './modules/SubInfoList'
import LakalaBalance from './modules/LakalaBalance'
import { tableMixin } from '@/store/table-mixin'
import {downLoadExcel} from "@/utils/excelDownload";

export default {
  name: 'ExtraApplyLakala',
  components: {
    CustomDictTag,
    CreateForm,
    BindList,
    SubInfoList,
    LakalaBalance
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      merchantId: undefined,
      merchantType: undefined,
      // 查询参数
      queryParam: {
        merchantId: undefined,
        orderNo: undefined,
        posType: undefined,
        orgCode: undefined,
        merRegName: undefined,
        merBizName: undefined,
        merRegDistCode: undefined,
        merRegAddr: undefined,
        mccCode: undefined,
        merBlisName: undefined,
        merBlis: undefined,
        merBlisStDt: undefined,
        merBlisExpDt: undefined,
        larName: undefined,
        larIdType: undefined,
        larIdcard: undefined,
        larIdcardStDt: undefined,
        larIdcardExpDt: undefined,
        merContactMobile: undefined,
        merContactName: undefined,
        shopName: undefined,
        shopDistCode: undefined,
        shopAddr: undefined,
        shopContactName: undefined,
        shopContactMobile: undefined,
        openingBankCode: undefined,
        openingBankName: undefined,
        clearingBankCode: undefined,
        acctNo: undefined,
        acctName: undefined,
        acctTypeCode: undefined,
        settlePeriod: undefined,
        clearDt: undefined,
        acctIdType: undefined,
        acctIdcard: undefined,
        acctIdDt: undefined,
        devSerialNo: undefined,
        devTypeName: undefined,
        termVer: undefined,
        salesStaff: undefined,
        termNum: undefined,
        retUrl: undefined,
        feeData: undefined,
        fileData: undefined,
        contractNo: undefined,
        feeAssumeType: undefined,
        amountOfMonth: undefined,
        serviceFee: undefined,
        contractId: undefined,
        contractStatus: undefined,
        contractMemo: undefined,
        merInnerNo: undefined,
        merCupNo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商户注册名称'),
          dataIndex: 'merRegName',
          align: 'center'
        },
        {
          title: this.$t('进件状态'),
          dataIndex: 'contractStatus',
          scopedSlots: { customRender: 'contractStatus' },
          align: 'center'
        },
        {
          title: this.$t('审核理由'),
          dataIndex: 'contractMemo',
          align: 'center'
        },
        {
          title: this.$t('分账状态'),
          dataIndex: 'splitStatus',
          scopedSlots: { customRender: 'splitStatus' },
          align: 'center'
        },
        {
          title: this.$t('内部商户号'),
          dataIndex: 'merInnerNo',
          align: 'center'
        },
        {
          title: this.$t('银联商户号'),
          dataIndex: 'merCupNo',
          align: 'center'
        },
        {
          title: this.$t('营业执照名称'),
          dataIndex: 'merBlisName',
          align: 'center'
        },
        {
          title: this.$t('营业执照编号'),
          dataIndex: 'merBlis',
          align: 'center'
        },
        {
          title: this.$t('法人姓名'),
          dataIndex: 'larName',
          align: 'center'
        },
        {
          title: this.$t('法人身份证号码'),
          dataIndex: 'larIdcard',
          align: 'center'
        },
        {
          title: this.$t('商户联系人手机'),
          dataIndex: 'merContactMobile',
          align: 'center'
        },
        {
          title: this.$t('商户联系人'),
          dataIndex: 'merContactName',
          align: 'center'
        },
        {
          title: this.$t('结算账户开户行名称'),
          dataIndex: 'openingBankName',
          align: 'center'
        },
        {
          title: this.$t('结算账户账号'),
          dataIndex: 'acctNo',
          align: 'center'
        },
        {
          title: this.$t('结算账户名称'),
          dataIndex: 'acctName',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.pushMerchantId()
    this.getList()
  },
  mounted() {
    this.pushMerchantId()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    pushMerchantId() {
      let merchantId = this.$route.query.merchantId;
      if (merchantId) {
        this.merchantId = merchantId;
        this.merchantType = Number(this.$route.query.merchantType);
      }
    },
    /** 查询商家进件-拉卡拉列表 */
    getList () {
      this.loading = true
      this.queryParam.merchantId = this.merchantId
     pageExtraApplyLakala(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    handleAdd() {
      //查询有没有进件记录
      this.$refs.createForm.handleAdd(this.merchantId, this.total);
    },
    showWeixinCode() {
      this.handleRecordPreview("https://static.byg1688.com/merchant/2025/10/15/17605095977898yctCGsr7KycUhL.png");
    },
    showAlipayCode() {
      this.handleRecordPreview("https://static.byg1688.com/merchant/2025/10/15/1760516701416Hl0jJrWIfAMDKOQ.png");
    },
    showWeixinHelp() {
      window.open("https://static.byg1688.com/merchant/%E5%BE%AE%E4%BF%A1%E6%94%AF%E4%BB%98%E5%95%86%E5%AE%B6%E5%AE%9E%E5%90%8D%E9%AA%8C%E8%AF%81%E6%93%8D%E4%BD%9C-%E5%90%AB%E9%9D%9E%E6%B3%95%E4%BA%BA%E6%93%8D%E4%BD%9C.pdf", '_blank');
    },
    showAlipayHelp() {
      window.open("https://static.byg1688.com/merchant/%E6%94%AF%E4%BB%98%E5%AE%9D%E5%95%86%E5%AE%B6%E8%AE%A4%E8%AF%81%E6%93%8D%E4%BD%9C-%E5%8C%85%E5%90%AB%E9%9D%9E%E6%B3%95%E4%BA%BA%E6%93%8D%E4%BD%9C.pdf", '_blank');
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: undefined,
        orderNo: undefined,
        posType: undefined,
        orgCode: undefined,
        merRegName: undefined,
        merBizName: undefined,
        merRegDistCode: undefined,
        merRegAddr: undefined,
        mccCode: undefined,
        merBlisName: undefined,
        merBlis: undefined,
        merBlisStDt: undefined,
        merBlisExpDt: undefined,
        larName: undefined,
        larIdType: undefined,
        larIdcard: undefined,
        larIdcardStDt: undefined,
        larIdcardExpDt: undefined,
        merContactMobile: undefined,
        merContactName: undefined,
        shopName: undefined,
        shopDistCode: undefined,
        shopAddr: undefined,
        shopContactName: undefined,
        shopContactMobile: undefined,
        openingBankCode: undefined,
        openingBankName: undefined,
        clearingBankCode: undefined,
        acctNo: undefined,
        acctName: undefined,
        acctTypeCode: undefined,
        settlePeriod: undefined,
        clearDt: undefined,
        acctIdType: undefined,
        acctIdcard: undefined,
        acctIdDt: undefined,
        devSerialNo: undefined,
        devTypeName: undefined,
        termVer: undefined,
        salesStaff: undefined,
        termNum: undefined,
        retUrl: undefined,
        feeData: undefined,
        fileData: undefined,
        contractNo: undefined,
        feeAssumeType: undefined,
        amountOfMonth: undefined,
        serviceFee: undefined,
        contractId: undefined,
        contractStatus: undefined,
        contractMemo: undefined,
        merInnerNo: undefined,
        merCupNo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleLakalaApply(record) {
      this.loading = true
      extraApplyLakalaApply({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件成功待审核",3)
          this.getList()
        }
      })
    },
    handleLakalaEdit(record) {
      this.loading = true
      extraApplyLakalaEdit({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件修改成功待审核",3)
          this.getList()
        }
      })
    },
    handleLedgerApply(record) {
      this.loading = true
      extraApplyLedgerApply({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("待审核",3)
          this.getList();
        }
      })
    },
    handleLedgerUpdate(record) {
      this.loading = true
      extraApplyLedgerUpdate({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("待审核",3)
          this.getList();
        }
      })
    },
    handleLedgerReceiver(record) {
      this.loading = true
      extraApplyLedgerApplyReceiverNo({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("待审核, 预计审核日1天",3)
          this.getList()
        }
      })
    },

    handleBind(record) {
      this.loading = true
      ledgerBind({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("绑定成功待审核",3)
          this.getList();
        }
      })
    },
    handleEc(record) {
      this.loading = true
      signExtraApplyEc({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          let dataUrl = response.data;
          //打开连接
          window.open(dataUrl, '_blank')
        }
      })
    },
    handleEcDownload(record) {
      downloadExtraApplyEc({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          let dataUrl = response.data;
          this.downloadPureBase64(dataUrl, record.merRegName+"-支付服务合作协议.pdf","application/pdf");
        }
      })
    },

    downloadPureBase64(base64String, fileName, mimeType) {
      let base64Data = base64String;
      const aLink = document.createElement('a')
      // 转换为 Blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });      // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
      aLink.style.display = 'none'
      aLink.href = URL.createObjectURL(blob)
      aLink.setAttribute('download', fileName) // 设置下载文件名称
      document.body.appendChild(aLink)
      aLink.click()
      URL.revokeObjectURL(aLink.href) // 清除引用
      document.body.appendChild(aLink)
    },


    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delExtraApplyLakala(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          downLoadExcel('merchant/extra/apply/lakala/export', that.queryParam)
        },
        onCancel () {}
      })
    }
  }
}
</script>
